import * as React from 'react';
export class StackTabsRenderer extends React.PureComponent {
    render() {
        return React.createElement("div", { style: { display: 'grid', gridTemplateColumns: `${this.props.stack.items.map(() => 'minmax(min-content, max-content)').join(' ')} 1fr` } }, this.props.children);
    }
}
//# sourceMappingURL=stack-tabs-renderer.js.map